import { render, staticRenderFns } from "./IdentitySuccess.vue?vue&type=template&id=458fc31a&scoped=true"
import script from "./IdentitySuccess.vue?vue&type=script&lang=js"
export * from "./IdentitySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458fc31a",
  null
  
)

export default component.exports